export default "__VITE_PUBLIC_ASSET__526d4f64__"